"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluTypes = exports.PosVendor = exports.PosDataServiceMode = exports.VendorConfigPosVendors = exports.PluConfigPosVendors = exports.Override = exports.Channel = exports.CartServiceMode = void 0;
var CartServiceMode;
(function (CartServiceMode) {
    CartServiceMode["cateringDelivery"] = "CATERING_DELIVERY";
    CartServiceMode["cateringPickup"] = "CATERING_PICKUP";
    CartServiceMode["curbside"] = "CURBSIDE";
    CartServiceMode["delivery"] = "DELIVERY";
    CartServiceMode["driveThru"] = "DRIVE_THRU";
    CartServiceMode["eatIn"] = "EAT_IN";
    CartServiceMode["takeout"] = "TAKEOUT";
    CartServiceMode["tableService"] = "TABLE_SERVICE";
})(CartServiceMode = exports.CartServiceMode || (exports.CartServiceMode = {}));
var Channel;
(function (Channel) {
    Channel["whitelabel"] = "whitelabel";
    Channel["gfo"] = "gfo";
    Channel["catering"] = "catering";
    Channel["waitr"] = "waitr";
    Channel["skip"] = "skip";
    Channel["uber"] = "uber";
    Channel["biteninja"] = "biteninja";
    Channel["doordash"] = "doordash";
    Channel["grubhub"] = "grubhub";
    Channel["in_store"] = "in_store";
    Channel["glovo"] = "glovo";
    Channel["just_eat"] = "just_eat";
    Channel["bolt"] = "bolt";
})(Channel = exports.Channel || (exports.Channel = {}));
var Override;
(function (Override) {
    Override["lateNight"] = "lateNight";
})(Override = exports.Override || (exports.Override = {}));
var PluConfigPosVendors;
(function (PluConfigPosVendors) {
    PluConfigPosVendors["CARROLS"] = "carrols";
    PluConfigPosVendors["CONNECTOR"] = "connector";
    PluConfigPosVendors["NCR"] = "ncr";
    PluConfigPosVendors["PARTNER"] = "partner";
    PluConfigPosVendors["PRODUCT_NUMBER"] = "productNumber";
    PluConfigPosVendors["QDI"] = "qdi";
    PluConfigPosVendors["QST"] = "qst";
    PluConfigPosVendors["OHEICS"] = "oheics";
    PluConfigPosVendors["RPOS"] = "rpos";
    PluConfigPosVendors["SICOM"] = "sicom";
    PluConfigPosVendors["SIMPLY_DELIVERY"] = "simplyDelivery";
    PluConfigPosVendors["TABLET"] = "tablet";
    PluConfigPosVendors["TOSHIBA_LOYALTY"] = "toshibaLoyalty";
})(PluConfigPosVendors = exports.PluConfigPosVendors || (exports.PluConfigPosVendors = {}));
var VendorConfigPosVendors;
(function (VendorConfigPosVendors) {
    VendorConfigPosVendors["CARROLS"] = "carrols";
    VendorConfigPosVendors["CARROLS_DELIVERY"] = "carrolsDelivery";
    VendorConfigPosVendors["NCR"] = "ncr";
    VendorConfigPosVendors["NCR_DELIVERY"] = "ncrDelivery";
    VendorConfigPosVendors["PARTNER"] = "partner";
    VendorConfigPosVendors["PARTNER_DELIVERY"] = "partnerDelivery";
    VendorConfigPosVendors["PRODUCT_NUMBER"] = "productNumber";
    VendorConfigPosVendors["PRODUCT_NUMBER_DELIVERY"] = "productNumberDelivery";
    VendorConfigPosVendors["QDI"] = "qdi";
    VendorConfigPosVendors["QDI_DELIVERY"] = "qdiDelivery";
    VendorConfigPosVendors["QST"] = "qst";
    VendorConfigPosVendors["QST_DELIVERY"] = "qstDelivery";
    VendorConfigPosVendors["OHEICS"] = "oheics";
    VendorConfigPosVendors["OHEICS_DELIVERY"] = "oheicsDelivery";
    VendorConfigPosVendors["RPOS"] = "rpos";
    VendorConfigPosVendors["RPOS_DELIVERY"] = "rposDelivery";
    VendorConfigPosVendors["SICOM"] = "sicom";
    VendorConfigPosVendors["SICOM_DELIVERY"] = "sicomDelivery";
    VendorConfigPosVendors["SIMPLY_DELIVERY"] = "simplyDelivery";
    VendorConfigPosVendors["SIMPLY_DELIVERY_DELIVERY"] = "simplyDeliveryDelivery";
    VendorConfigPosVendors["TABLET"] = "tablet";
    VendorConfigPosVendors["TABLET_DELIVERY"] = "tabletDelivery";
    VendorConfigPosVendors["TOSHIBA_LOYALTY"] = "toshibaLoyalty";
})(VendorConfigPosVendors = exports.VendorConfigPosVendors || (exports.VendorConfigPosVendors = {}));
var PosDataServiceMode;
(function (PosDataServiceMode) {
    PosDataServiceMode["delivery"] = "delivery";
    PosDataServiceMode["pickup"] = "pickup";
})(PosDataServiceMode = exports.PosDataServiceMode || (exports.PosDataServiceMode = {}));
/**
 * This was specifically added to remove the dependency of intl-common.
 * Since PluConfigs is used on frontend/backend projects, we're aiming to keep
 * menu package isomorphic.
 */
var PosVendor;
(function (PosVendor) {
    /**
     * Carrols (a.k.a. Xenial)
     */
    PosVendor["CARROLS"] = "CARROLS";
    /**
     * IMPORTANT: DO NOT USE THE "CONNECTOR" PosVendor!
     *
     * The "Connector" POS is represented as "PRODUCT_NUMBER."
     */
    PosVendor["CONNECTOR"] = "CONNECTOR";
    /**
     * National Cash Register (NCR) / and NCR Enterprise Platform (NEP)
     */
    PosVendor["NCR"] = "NCR";
    /**
     * Oracle Hospitality eCommerce Integration Cloud Service
     * also known as Oracle
     * also know as Micros
     */
    PosVendor["OHEICS"] = "OHEICS";
    /**
     * Used for Partner API to allow 3rd parties to integrate with us
     */
    PosVendor["PARTNER"] = "PARTNER";
    /**
     * Tim Horton's Connector (a.k.a Product Number)
     */
    PosVendor["PRODUCT_NUMBER"] = "PRODUCT_NUMBER";
    /**
     * rPOS / RBI POS (f.k.a. MediaWorks)
     */
    PosVendor["RPOS"] = "RPOS";
    PosVendor["SIMPLY_DELIVERY"] = "SIMPLY_DELIVERY";
    PosVendor["QDI"] = "QDI";
    PosVendor["QST"] = "QST";
    PosVendor["SICOM"] = "SICOM";
    PosVendor["TABLET"] = "TABLET";
    PosVendor["TOSHIBA_LOYALTY"] = "TOSHIBA_LOYALTY";
})(PosVendor = exports.PosVendor || (exports.PosVendor = {}));
var PluTypes;
(function (PluTypes) {
    PluTypes["CONSTANT"] = "constantPlu";
    PluTypes["EMPTY"] = "empty";
    PluTypes["IGNORE"] = "ignore";
    PluTypes["MULTI_CONSTANT"] = "multiConstantPlus";
    PluTypes["PARENT_CHILD"] = "parentChildPlu";
    PluTypes["QUANTITY"] = "quantityBasedPlu";
    PluTypes["SIZE_BASED"] = "sizeBasedPlu";
})(PluTypes = exports.PluTypes || (exports.PluTypes = {}));
//# sourceMappingURL=schemata.js.map